export default class Loader{
    createLoader(){
        let createDiv = document.createElement('div');
        createDiv.classList.add('col-12', 'd-flex', 'justify-content-center', 'create-loader')

        let loaderDiv = document.createElement('div');
        loaderDiv.className = 'loader';
        createDiv.appendChild(loaderDiv);

        return createDiv;
    }

    addLoader(form) {
        let divLoader = this.createLoader();
        if(!form.querySelector('.create-loader')){
            form.appendChild(divLoader);
            window.scrollBy(0, 100);
        }
    }
    removeLoader(){
        if(document.querySelector('.create-loader')){
            document.querySelector('.create-loader').remove();
        }
    }
}
